<template>
  <span class="font-weight-bold">{{ formattedValue }}</span>
</template>

<script>
export default {
  props: {
    value: {
      type: [Number, String],
    },
    mediaMinima: {
      type: Number,
      default: 7,
    },
    max: {
      type: Number,
      default: 80,
    },
    arredondamento: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    value(val) {
      if (val > this.max) {
        this.$emit("change", parseFloat(this.max, 10));
      }
    },
  },
  created() {
    if (this.value > this.max) {
      this.$emit("change", parseFloat(this.max, 10));
    }
  },
  computed: {
    valueIsEmpty() {
      return (
        this.value === null ||
        this.value === undefined ||
        this.value === "" ||
        isNaN(parseFloat(this.value))
      );
    },
    valueAsNumber() {
      return this.valueIsEmpty ? null : parseFloat(this.value);
    },
    formattedValue() {
      if (this.valueIsEmpty) return "- - -";

      let val = this.valueAsNumber;

      // Aplica limite máximo
      if (val > this.max) val = this.max;

      // Se for para arredondar, aplica regra
      if (this.arredondamento) {
        val = this.roundValue(val);
      }

      // Formata sempre com 1 casa decimal
      return val <= this.max ? Math.floor(val * 10) / 10 : this.max;
    },
  },
  methods: {
    roundValue(val) {
      const decimalPart = val % 1;
      if (decimalPart < 0.5) {
        return Math.floor(val);
      } else {
        return Math.ceil(val);
      }
    },
  },
};
</script>
